import {FC} from 'react'

import {useUserData} from '@/components/context/UserData'
import {HEADER_AUTH_SLOT_HEIGHT} from '@/theme/sizing'

import {HeaderAuthPlaceholder} from './HeaderAuthPlaceholder'
import {LoginButton} from './login/LoginButton'
import {UserAvatar} from './user/UserAvatar'

/**
 * The header's auth slot: placeholder, then the login button or avatar once we know the user.
 * Auth is only resolved client-side, so the placeholder is what's in the HTML, and the real
 * control swaps in after hydration.
 */
export const HeaderAuthAction: FC = () => {
  const {isLoggedIn, isAuthPending} = useUserData()

  return (
    <>
      <div className="auth-slot">
        {isAuthPending ? <HeaderAuthPlaceholder /> : isLoggedIn ? <UserAvatar /> : <LoginButton />}
      </div>

      <style jsx>{`
        .auth-slot {
          display: flex;
          align-items: center;
          height: ${HEADER_AUTH_SLOT_HEIGHT};
        }
      `}</style>
    </>
  )
}
